<template>
  <div class="container">

    <heading-one class="-margin-md">収入証明書のご提出</heading-one>

    <wizard-group class="_mb-sm-35 _mb-md-50">
      <main-wizard :active-index="2" type="income"></main-wizard>
    </wizard-group>

    <section>

      <heading-three>アップロード前にご確認ください</heading-three>
      <p>以下の場合は、再提出が必要となりますのでご注意ください。</p>
      <list-group class="-normal _mb-sm-30 _mb-md-50">
        <list-item class="-normal">画像が極端に小さい、切れている、ぼやけている</list-item>
        <list-item class="-normal">本籍地、個人番号（マイナンバー）などが記載されており紙などで隠されていない状態</list-item>
      </list-group>

      <div class="row">
        <template v-if="certificate === '02'">
          <div v-if="!!userData.file_data1" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 1</heading-three>
            <confirm-image :file-name="userData.file_name1" :file-data="userData.file_data1"></confirm-image>
          </div>
          <div v-if="!!userData.file_data2" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 2</heading-three>
            <confirm-image :file-name="userData.file_name2" :file-data="userData.file_data2"></confirm-image>
          </div>
          <div v-if="!!userData.file_data3" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 3</heading-three>
            <confirm-image :file-name="userData.file_name3" :file-data="userData.file_data3"></confirm-image>
          </div>
          <div v-if="!!userData.file_data4" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 4</heading-three>
            <confirm-image :file-name="userData.file_name4" :file-data="userData.file_data4"></confirm-image>
          </div>
          <div v-if="!!userData.file_data5" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 5</heading-three>
            <confirm-image :file-name="userData.file_name5" :file-data="userData.file_data5"></confirm-image>
          </div>
          <div v-if="pension === '02' && !!userData.file_data6" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 6</heading-three>
            <confirm-image :file-name="userData.file_name6" :file-data="userData.file_data6"></confirm-image>
          </div>
        </template>
        <template v-else>
          <div v-if="!!userData.file_data1" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 1</heading-three>
            <confirm-image :file-name="userData.file_name1" :file-data="userData.file_data1"></confirm-image>
          </div>
          <div v-if="pension === '02' && !!userData.file_data6" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>ファイル 2</heading-three>
            <confirm-image :file-name="userData.file_name6" :file-data="userData.file_data6"></confirm-image>
          </div>
        </template>
      </div>

      <form @submit.prevent="submitIdentifyFile">
        <btngroup-single class="_mb-sm-40">
          <btn-main class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </btn-main>
        </btngroup-single>
      </form>

      <btngroup-single class="-margin-lg">
        <btn-back class="-back -md" @click.prevent="goBack">
          修正する
        </btn-back>
      </btngroup-single>

    </section>

  </div><!-- container -->
</template>

<script>
import { initCredentials } from '../../utils/Auth'
import { getUserDataLambdaInvoke, submitIdentifyFileLambdaInvoke } from '../../utils/LambdaHelper'
import { INCOME_CERTIFICATE_IMAGE_AT } from '../../constants/constant'

import HeadingOne from '../../components/heading/HeadingOne'
import HeadingThree from '../../components/heading/HeadingThree'
import MainWizard from '../../components/wizard/MainWizard'
import WizardGroup from '../../components/wizard/WizardGroup'
import BtnMain from '../../components/button/BtnMain'
import BtnBack from '../../components/button/BtnBack'
import BtngroupSingle from '../../components/button/BtngroupSingle'
import CardBox from '../../components/card/CardBox'
import CardHeader from '../../components/card/CardHeader'
import CardBody from '../../components/card/CardBody'
import ConfirmImage from '../../components/upload/ConfirmImage'
import ListGroup from '../../components/list/ListGroup'
import ListItem from '../../components/list/ListItem'

export default {
  name: 'income-confirm',

  components: {
    ListItem,
    ListGroup,
    ConfirmImage,
    HeadingThree,
    CardBody,
    CardHeader,
    CardBox,
    BtngroupSingle,
    BtnBack,
    BtnMain,
    WizardGroup,
    MainWizard,
    HeadingOne
  },
  props: {
    topPageId: '',
    previousPageId: '',
    nextPageId: ''
  },
  data () {
    return {
      certificate: this.$route.query.certificate,
      pension: this.$route.query.pension,
      pensionDoc: this.$route.query.pensionDoc,
      isDisabled: false,
      files: true,
      userData: {
        processing_type: '2',
        file_name1: '',
        file_data1: '',
        file_name2: '',
        file_data2: '',
        file_name3: '',
        file_data3: '',
        file_name4: '',
        file_data4: '',
        file_name5: '',
        file_data5: '',
        file_name6: '',
        file_data6: ''
      }
    }
  },
  methods: {
    submitIdentifyFile: function (event) {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.checkQueryParam()

        initCredentials().then(res => {
          submitIdentifyFileLambdaInvoke().then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else {
              window.$cookies.set(INCOME_CERTIFICATE_IMAGE_AT, (new Date()).toJSON(), '15min', '/', null, process.env.COOKIES_SECURE)
              this.$router.push({name: this.nextPageId})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    goBack: function () {
      try {
        let queryParam = {
          certificate: this.certificate || '00',
          pension: this.pension || '01',
          pensionDoc: this.pensionDoc || '00'
        }
        this.$router.push({name: this.previousPageId, query: queryParam})
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    checkQueryParam () {
      try {
        if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendering) {
          // ビルド時の静的ファイル生成時はチェックしない
          return
        }
        if (['01', '02', '03', '04', '05'].indexOf(this.$route.query.certificate) === -1) {
          this.$router.push({name: this.topPageId})
        }
        if (['01', '02'].indexOf(this.$route.query.pension) === -1) {
          this.$router.push({name: this.topPageId})
        }
        if (['02'].indexOf(this.$route.query.pension) === 0) {
          if (['01', '02'].indexOf(this.$route.query.pensionDoc) === -1) {
            this.$router.push({name: this.topPageId})
          }
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  },
  created () {
    this.checkQueryParam()
  },
  mounted () {
    try {
      getUserDataLambdaInvoke(this.files).then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .card-header {
    background-color: transparent;
    border-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/fileupload/IncomeConfirm.vue